unit SchoolEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  Data.DB,
  WEBLib.DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls,
  WEBLib.DBCtrls,
  WebLib.CDS,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  WEBLib.WebCtrls,
  XData.Web.JsonDataset,
  XData.Web.Dataset;

type
  TSchoolEditForm = class(TBaseEditForm)
    ExternalId: TDBEdit;
    LocationName: TDBEdit;
    SchoolKind: TDBComboBox;
    SchoolAcademy: TDBLookupComboBox;
    AcademySource: TDataSource;
    RecordId: TDBLabel;
    Add1: TDBEdit;
    Town: TDBEdit;
    PostCode: TDBEdit;
    Telephone: TDBEdit;
    Email: TDBEdit;
    LocalAuthority: TDBEdit;
    Status: TDBComboBox;
    PupilCount: TDBEdit;
    CostingDataSource: TDataSource;
    CostingId: TDBLookupComboBox;
    RecordIdEdit: TDBEdit;
    PONumberEdit: TDBEdit;
    procedure SaveButtonClick(Sender: TObject);

  private
    { Private declarations }
    FIsInsert: Boolean;

    [async]
    procedure Save; async;

    procedure SetIsInsert(Value: Boolean);

  protected
    function GetRequiredEditLevel: string; override;

  public
    { Public declarations }
    [async]
    procedure InitForm; async; override;

    property IsInsert: Boolean read FIsInsert write SetIsInsert;

  protected procedure LoadDFMValues; override; end;

var
  SchoolEditForm: TSchoolEditForm;

implementation

{$R *.dfm}

uses
  Rtti,
  // SchoolsPage, //Use this only in design mode and set the EditSource.Dataset to MainDataset. Unlink it and comment this out before build
  App.Enumerations,
  MainDataModule,
  App.Shared,
  XData.Dataset.Utils,
  XData.Web.Client;

{ TSchoolEditForm }

procedure TSchoolEditForm.InitForm;
var
  lSchoolKind: TSchoolKind;
  oSchoolStatus: TSchoolStatus;

begin
  inherited;

  for lSchoolKind := Low(TSchoolKind) to High(TSchoolKind) do
    SchoolKind.Items.Add(TRttiEnumerationType.GetName<TSchoolKind>(lSchoolKind));

  for oSchoolStatus := Low(TSchoolStatus) to High(TSchoolStatus) do
    Status.Items.Add(TRttiEnumerationType.GetName<TSchoolStatus>(oSchoolStatus));

  MainData.OpenCostingLookUp;
  CostingDataSource.DataSet := MainData.CostingLookUp;
  AcademySource.DataSet := MainData.AcademyLookUp;

end;

function TSchoolEditForm.GetRequiredEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

procedure TSchoolEditForm.Save;
var
  oResultList: TResolveResults;
  iIdx: Integer;
  oInfo: TResolveInfo;
  bHasErrors: Boolean;
  sErrors: string;

  jsEntity: TJSObject;
  oResponse: TXDataClientResponse;

begin
  FSaveMessagesHandled := False;

  if not CanSaveThis then
  begin
    ShowMessage('Some details need completing before you can save this');
    Exit;

  end;

  BeforePostRecord;

  if IsInsert then
  begin
    jsEntity := TJSObject(TXDataWebDataset(Dataset).CurrentData);

    WebClient.RawInvoke(
      'ISchoolService.CreateSchool',
      [jsEntity],
      procedure(Response: TXDataClientResponse)
      begin
        // POST successful
        if CloseOnSave then
        begin
          ShowAToast(SaveTitle, SaveDescription, 'ok.png');
          WaitMessage.Show;
          CloseTimer.Enabled := True;

        end;

      end,
      procedure(Error: TXDataClientError)
      begin
        // POST failed
        ShowMessage('Error saving record: ' + Error.ErrorMessage);
        Dataset.Cancel;

      end
    );

  end
  else
  begin
    // Normal update logic
    DataSource.Dataset.Post;
    TXDataWebDataset(Dataset).ApplyUpdates;

    if CloseOnSave then
    begin
      ShowAToast(SaveTitle, SaveDescription, 'ok.png');
      WaitMessage.Show;
      CloseTimer.Enabled := True;

    end;

  end;

end;

procedure TSchoolEditForm.SaveButtonClick(Sender: TObject);
begin
  Save;

end;

procedure TSchoolEditForm.SetIsInsert(Value: Boolean);
begin
  FIsInsert := Value;
  RecordIdEdit.Enabled := FIsInsert;

end;

procedure TSchoolEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  RecordId := TDBLabel.Create('record-id');
  ExternalId := TDBEdit.Create('external-id');
  LocationName := TDBEdit.Create('location-name');
  SchoolKind := TDBComboBox.Create('school-kind');
  SchoolAcademy := TDBLookupComboBox.Create('school-academy');
  Add1 := TDBEdit.Create('add-1');
  Town := TDBEdit.Create('town');
  PostCode := TDBEdit.Create('postcode');
  Telephone := TDBEdit.Create('telephone');
  Email := TDBEdit.Create('email');
  LocalAuthority := TDBEdit.Create('local-authority');
  Status := TDBComboBox.Create('school-status');
  PupilCount := TDBEdit.Create('pupil-count');
  CostingId := TDBLookupComboBox.Create('costing-id');
  RecordIdEdit := TDBEdit.Create('record-id');
  PONumberEdit := TDBEdit.Create('po-number');
  AcademySource := TDataSource.Create(Self);
  CostingDataSource := TDataSource.Create(Self);

  RecordId.BeforeLoadDFMValues;
  ExternalId.BeforeLoadDFMValues;
  LocationName.BeforeLoadDFMValues;
  SchoolKind.BeforeLoadDFMValues;
  SchoolAcademy.BeforeLoadDFMValues;
  Add1.BeforeLoadDFMValues;
  Town.BeforeLoadDFMValues;
  PostCode.BeforeLoadDFMValues;
  Telephone.BeforeLoadDFMValues;
  Email.BeforeLoadDFMValues;
  LocalAuthority.BeforeLoadDFMValues;
  Status.BeforeLoadDFMValues;
  PupilCount.BeforeLoadDFMValues;
  CostingId.BeforeLoadDFMValues;
  RecordIdEdit.BeforeLoadDFMValues;
  PONumberEdit.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  AcademySource.BeforeLoadDFMValues;
  CostingDataSource.BeforeLoadDFMValues;
  try
    Caption := 'Id';
    RecordId.SetParentComponent(Self);
    RecordId.Name := 'RecordId';
    RecordId.Left := 431;
    RecordId.Top := 107;
    RecordId.Width := 47;
    RecordId.Height := 15;
    RecordId.Caption := 'RecordId';
    RecordId.ElementFont := efCSS;
    RecordId.ElementPosition := epIgnore;
    RecordId.HeightStyle := ssAuto;
    RecordId.HeightPercent := 100.000000000000000000;
    RecordId.WidthStyle := ssAuto;
    RecordId.WidthPercent := 100.000000000000000000;
    RecordId.DataField := 'Id';
    ExternalId.SetParentComponent(Self);
    ExternalId.Name := 'ExternalId';
    ExternalId.Left := 39;
    ExternalId.Top := 128;
    ExternalId.Width := 121;
    ExternalId.Height := 22;
    ExternalId.ChildOrder := 3;
    ExternalId.ElementClassName := 'form-control';
    ExternalId.ElementFont := efCSS;
    ExternalId.ElementPosition := epIgnore;
    ExternalId.HeightStyle := ssAuto;
    ExternalId.HeightPercent := 100.000000000000000000;
    ExternalId.MaxLength := 75;
    ExternalId.Text := 'ExternalId';
    ExternalId.WidthStyle := ssAuto;
    ExternalId.WidthPercent := 100.000000000000000000;
    ExternalId.DataField := 'ExternalId';
    ExternalId.DataSource := DataSource;
    LocationName.SetParentComponent(Self);
    LocationName.Name := 'LocationName';
    LocationName.Left := 39;
    LocationName.Top := 156;
    LocationName.Width := 121;
    LocationName.Height := 22;
    LocationName.ChildOrder := 3;
    LocationName.ElementClassName := 'form-control';
    LocationName.ElementFont := efCSS;
    LocationName.ElementPosition := epIgnore;
    LocationName.HeightStyle := ssAuto;
    LocationName.HeightPercent := 100.000000000000000000;
    LocationName.MaxLength := 255;
    LocationName.TabOrder := 1;
    LocationName.Text := 'LocationName';
    LocationName.WidthStyle := ssAuto;
    LocationName.WidthPercent := 100.000000000000000000;
    LocationName.DataField := 'LocationName';
    LocationName.DataSource := DataSource;
    SchoolKind.SetParentComponent(Self);
    SchoolKind.Name := 'SchoolKind';
    SchoolKind.Left := 191;
    SchoolKind.Top := 156;
    SchoolKind.Width := 145;
    SchoolKind.Height := 23;
    SchoolKind.ElementClassName := 'form-select form-control';
    SchoolKind.ElementFont := efCSS;
    SchoolKind.HeightStyle := ssAuto;
    SchoolKind.HeightPercent := 100.000000000000000000;
    SchoolKind.TabOrder := 9;
    SchoolKind.Text := 'SchoolKind';
    SchoolKind.WidthPercent := 100.000000000000000000;
    SchoolKind.ItemIndex := -1;
    SchoolKind.DataField := 'SchoolKind';
    SchoolKind.DataSource := DataSource;
    SchoolAcademy.SetParentComponent(Self);
    SchoolAcademy.Name := 'SchoolAcademy';
    SchoolAcademy.Left := 191;
    SchoolAcademy.Top := 128;
    SchoolAcademy.Width := 145;
    SchoolAcademy.Height := 22;
    SchoolAcademy.ElementClassName := 'form-select form-control';
    SchoolAcademy.ElementFont := efCSS;
    SchoolAcademy.ElementPosition := epIgnore;
    SchoolAcademy.HeightStyle := ssAuto;
    SchoolAcademy.HeightPercent := 100.000000000000000000;
    SchoolAcademy.TabOrder := 8;
    SchoolAcademy.WidthStyle := ssAuto;
    SchoolAcademy.WidthPercent := 100.000000000000000000;
    SchoolAcademy.DataField := 'AcademyId';
    SchoolAcademy.DataSource := DataSource;
    SchoolAcademy.KeyField := 'Id';
    SchoolAcademy.ListField := 'Name';
    SchoolAcademy.ListSource := AcademySource;
    Add1.SetParentComponent(Self);
    Add1.Name := 'Add1';
    Add1.Left := 39;
    Add1.Top := 184;
    Add1.Width := 121;
    Add1.Height := 22;
    Add1.ChildOrder := 3;
    Add1.ElementClassName := 'form-control';
    Add1.ElementFont := efCSS;
    Add1.ElementPosition := epIgnore;
    Add1.HeightStyle := ssAuto;
    Add1.HeightPercent := 100.000000000000000000;
    Add1.MaxLength := 100;
    Add1.TabOrder := 2;
    Add1.Text := 'Add1';
    Add1.WidthStyle := ssAuto;
    Add1.WidthPercent := 100.000000000000000000;
    Add1.DataField := 'Add1';
    Add1.DataSource := DataSource;
    Town.SetParentComponent(Self);
    Town.Name := 'Town';
    Town.Left := 39;
    Town.Top := 212;
    Town.Width := 121;
    Town.Height := 22;
    Town.ChildOrder := 3;
    Town.ElementClassName := 'form-control';
    Town.ElementFont := efCSS;
    Town.ElementPosition := epIgnore;
    Town.HeightStyle := ssAuto;
    Town.HeightPercent := 100.000000000000000000;
    Town.MaxLength := 75;
    Town.TabOrder := 3;
    Town.Text := 'Town';
    Town.WidthStyle := ssAuto;
    Town.WidthPercent := 100.000000000000000000;
    Town.DataField := 'Town';
    Town.DataSource := DataSource;
    PostCode.SetParentComponent(Self);
    PostCode.Name := 'PostCode';
    PostCode.Left := 39;
    PostCode.Top := 240;
    PostCode.Width := 121;
    PostCode.Height := 22;
    PostCode.ChildOrder := 3;
    PostCode.ElementClassName := 'form-control';
    PostCode.ElementFont := efCSS;
    PostCode.ElementPosition := epIgnore;
    PostCode.HeightStyle := ssAuto;
    PostCode.HeightPercent := 100.000000000000000000;
    PostCode.MaxLength := 25;
    PostCode.TabOrder := 4;
    PostCode.Text := 'Postcode';
    PostCode.WidthStyle := ssAuto;
    PostCode.WidthPercent := 100.000000000000000000;
    PostCode.DataField := 'Postcode';
    PostCode.DataSource := DataSource;
    Telephone.SetParentComponent(Self);
    Telephone.Name := 'Telephone';
    Telephone.Left := 39;
    Telephone.Top := 268;
    Telephone.Width := 121;
    Telephone.Height := 22;
    Telephone.ChildOrder := 3;
    Telephone.EditType := weNumeric;
    Telephone.ElementClassName := 'form-control';
    Telephone.ElementFont := efCSS;
    Telephone.ElementPosition := epIgnore;
    Telephone.HeightStyle := ssAuto;
    Telephone.HeightPercent := 100.000000000000000000;
    Telephone.MaxLength := 25;
    Telephone.TabOrder := 5;
    Telephone.Text := 'Telephone';
    Telephone.WidthStyle := ssAuto;
    Telephone.WidthPercent := 100.000000000000000000;
    Telephone.DataField := 'Telephone';
    Telephone.DataSource := DataSource;
    Email.SetParentComponent(Self);
    Email.Name := 'Email';
    Email.Left := 39;
    Email.Top := 296;
    Email.Width := 121;
    Email.Height := 22;
    Email.ChildOrder := 3;
    Email.ElementClassName := 'form-control';
    Email.ElementFont := efCSS;
    Email.ElementPosition := epIgnore;
    Email.HeightStyle := ssAuto;
    Email.HeightPercent := 100.000000000000000000;
    Email.MaxLength := 320;
    Email.TabOrder := 6;
    Email.Text := 'Email';
    Email.WidthStyle := ssAuto;
    Email.WidthPercent := 100.000000000000000000;
    Email.DataField := 'Email';
    Email.DataSource := DataSource;
    LocalAuthority.SetParentComponent(Self);
    LocalAuthority.Name := 'LocalAuthority';
    LocalAuthority.Left := 39;
    LocalAuthority.Top := 324;
    LocalAuthority.Width := 121;
    LocalAuthority.Height := 22;
    LocalAuthority.ChildOrder := 3;
    LocalAuthority.ElementClassName := 'form-control';
    LocalAuthority.ElementFont := efCSS;
    LocalAuthority.ElementPosition := epIgnore;
    LocalAuthority.HeightStyle := ssAuto;
    LocalAuthority.HeightPercent := 100.000000000000000000;
    LocalAuthority.MaxLength := 50;
    LocalAuthority.TabOrder := 7;
    LocalAuthority.Text := 'LocalAuthority';
    LocalAuthority.WidthStyle := ssAuto;
    LocalAuthority.WidthPercent := 100.000000000000000000;
    LocalAuthority.DataField := 'LocalAuthority';
    LocalAuthority.DataSource := DataSource;
    Status.SetParentComponent(Self);
    Status.Name := 'Status';
    Status.Left := 191;
    Status.Top := 184;
    Status.Width := 145;
    Status.Height := 23;
    Status.ElementClassName := 'form-select form-control';
    Status.ElementFont := efCSS;
    Status.HeightStyle := ssAuto;
    Status.HeightPercent := 100.000000000000000000;
    Status.TabOrder := 10;
    Status.Text := 'Status';
    Status.WidthPercent := 100.000000000000000000;
    Status.ItemIndex := -1;
    Status.DataField := 'Status';
    Status.DataSource := DataSource;
    PupilCount.SetParentComponent(Self);
    PupilCount.Name := 'PupilCount';
    PupilCount.Left := 191;
    PupilCount.Top := 213;
    PupilCount.Width := 121;
    PupilCount.Height := 22;
    PupilCount.ChildOrder := 3;
    PupilCount.EditType := weNumeric;
    PupilCount.ElementClassName := 'form-control';
    PupilCount.ElementFont := efCSS;
    PupilCount.ElementPosition := epIgnore;
    PupilCount.HeightStyle := ssAuto;
    PupilCount.HeightPercent := 100.000000000000000000;
    PupilCount.TabOrder := 5;
    PupilCount.Text := 'PupilCount';
    PupilCount.WidthStyle := ssAuto;
    PupilCount.WidthPercent := 100.000000000000000000;
    PupilCount.DataField := 'PupilCount';
    PupilCount.DataSource := DataSource;
    CostingId.SetParentComponent(Self);
    CostingId.Name := 'CostingId';
    CostingId.Left := 191;
    CostingId.Top := 241;
    CostingId.Width := 145;
    CostingId.Height := 22;
    CostingId.ElementClassName := 'form-select form-control';
    CostingId.ElementFont := efCSS;
    CostingId.ElementPosition := epIgnore;
    CostingId.HeightStyle := ssAuto;
    CostingId.HeightPercent := 100.000000000000000000;
    CostingId.WidthStyle := ssAuto;
    CostingId.WidthPercent := 100.000000000000000000;
    CostingId.DataField := 'CostingId';
    CostingId.DataSource := DataSource;
    CostingId.KeyField := 'Id';
    CostingId.ListField := 'Title';
    CostingId.ListSource := CostingDataSource;
    RecordIdEdit.SetParentComponent(Self);
    RecordIdEdit.Name := 'RecordIdEdit';
    RecordIdEdit.Left := 431;
    RecordIdEdit.Top := 128;
    RecordIdEdit.Width := 121;
    RecordIdEdit.Height := 22;
    RecordIdEdit.ChildOrder := 3;
    RecordIdEdit.ElementClassName := 'form-control';
    RecordIdEdit.ElementFont := efCSS;
    RecordIdEdit.ElementPosition := epIgnore;
    RecordIdEdit.HeightStyle := ssAuto;
    RecordIdEdit.HeightPercent := 100.000000000000000000;
    RecordIdEdit.MaxLength := 75;
    RecordIdEdit.Text := 'RecordId';
    RecordIdEdit.WidthStyle := ssAuto;
    RecordIdEdit.WidthPercent := 100.000000000000000000;
    RecordIdEdit.DataField := 'Id';
    RecordIdEdit.DataSource := DataSource;
    PONumberEdit.SetParentComponent(Self);
    PONumberEdit.Name := 'PONumberEdit';
    PONumberEdit.Left := 191;
    PONumberEdit.Top := 268;
    PONumberEdit.Width := 145;
    PONumberEdit.Height := 22;
    PONumberEdit.ChildOrder := 3;
    PONumberEdit.ElementClassName := 'form-control';
    PONumberEdit.ElementFont := efCSS;
    PONumberEdit.ElementPosition := epIgnore;
    PONumberEdit.HeightStyle := ssAuto;
    PONumberEdit.HeightPercent := 100.000000000000000000;
    PONumberEdit.MaxLength := 75;
    PONumberEdit.Text := 'PO Number';
    PONumberEdit.WidthStyle := ssAuto;
    PONumberEdit.WidthPercent := 100.000000000000000000;
    PONumberEdit.DataField := 'PONumber';
    PONumberEdit.DataSource := DataSource;
    DataSource.Top := 16;
    AcademySource.SetParentComponent(Self);
    AcademySource.Name := 'AcademySource';
    AcademySource.Left := 672;
    AcademySource.Top := 48;
    CostingDataSource.SetParentComponent(Self);
    CostingDataSource.Name := 'CostingDataSource';
    CostingDataSource.Left := 672;
    CostingDataSource.Top := 112;
  finally
    RecordId.AfterLoadDFMValues;
    ExternalId.AfterLoadDFMValues;
    LocationName.AfterLoadDFMValues;
    SchoolKind.AfterLoadDFMValues;
    SchoolAcademy.AfterLoadDFMValues;
    Add1.AfterLoadDFMValues;
    Town.AfterLoadDFMValues;
    PostCode.AfterLoadDFMValues;
    Telephone.AfterLoadDFMValues;
    Email.AfterLoadDFMValues;
    LocalAuthority.AfterLoadDFMValues;
    Status.AfterLoadDFMValues;
    PupilCount.AfterLoadDFMValues;
    CostingId.AfterLoadDFMValues;
    RecordIdEdit.AfterLoadDFMValues;
    PONumberEdit.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    AcademySource.AfterLoadDFMValues;
    CostingDataSource.AfterLoadDFMValues;
  end;
end;

end.

